export default "__VITE_ASSET__CdH5G2rj__"